import { Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

interface SnackbarInput {
  message: string;
}

@Component({
  selector: 'snack-bar-warning',
  templateUrl: './warning.component.html',
  styleUrl: './warning.component.css',
})
export class WarningSnackBarComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarInput) {}
}
